import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NavigateToNode, NodeNavigatorActionTypes } from '@ispm-client/modules/bpmn-modeler/store/actions/node-navigator.action';
import { BpmnModelerService } from '@ispm-client/modules/bpmn-modeler/service/bpmn-modeler.service';

@Injectable()
export class NavigateNodeEffect {


  constructor(private actions$: Actions,
              private bpmnModelerService: BpmnModelerService) {
  }

  @Effect({ dispatch: false})
  navigateToNodeEffect$: Observable<Action> = this.actions$
    .pipe(
      ofType<NavigateToNode>(NodeNavigatorActionTypes.NAVIGATE_TO_NODE),
      tap((action: NavigateToNode) => {
        return this.bpmnModelerService.navigateToNode(action.payload.nodeId, action.payload.openPanel);
      })
    );

}
